<mat-sidenav-container fullscreen>
    <mat-sidenav-content>
    <div style="height:97vh" >
      <iframe [src]="iframUrl" *ngIf="iframUrl" marginwidth="0" marginheight="0" frameborder="0" width="100%" height="100%;" scrolling="yes" allowfullscreen="allowfullscreen"></iframe>
    </div>
   <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
       
   